// Description: Enum for play session types
enum ScoreTypes {
  TOTAL = "sum",
  AVERAGE = "avg",
  MAXIMUM = "max",
  MINIMUM = "min",
};

export default ScoreTypes;